import { cn } from '@/utilities/ui'
import { ReactElement } from 'react'
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import { Loader2 } from 'lucide-react'
import Link from 'next/link'
import { Button } from '@/components/ui/button'
import {
  buttonSizes,
  buttonColors,
  type ButtonSize,
  type ButtonColor,
} from '@/utilities/branding'

type Button = {
  text?: string
  children?: React.ReactNode
  loading?: boolean
  color?: ButtonColor
  onClick?: (e?: React.MouseEvent) => void
  className?: string
  href?: string
  target?: string
  size?: ButtonSize
  disabled?: boolean
}

export const SubmitButton = ({
  text,
  children,
  loading,
  color = 'primary',
  onClick,
  className,
  size = 'md',
  disabled = false,
}: Button): ReactElement => {
  return (
    <Button
      type="submit"
      variant="default"
      className={cn(
        'disabled:opacity-50 disabled:cursor-not-allowed',
        buttonSizes[size],
        buttonColors[color],
        className,
      )}
      disabled={loading || disabled}
      onClick={onClick}
    >
      {loading ? (
        <Loader2 className="animate-spin" size={16} />
      ) : (
        <AiOutlineLoading3Quarters className="hidden" />
      )}
      <span>{children || text}</span>
    </Button>
  )
}

export const ButtonLink = ({
  text,
  children,
  color = 'primary',
  className,
  href,
  target = '',
  size = 'md',
  onClick,
}: Button): ReactElement => {
  return (
    <Button
      asChild
      variant="default"
      className={cn(buttonSizes[size], buttonColors[color], className)}
    >
      <Link href={href || ''} target={target} onClick={onClick}>
        <span>{children || text}</span>
      </Link>
    </Button>
  )
}
